import React from 'react';
import './Blog.css'

const Blog = (props) => {
    const {id,name, describtion, img, Link } = props.alblog
    return (
        <div >
           <div className='blog-card'>
                <div className='card'>
                    <div className='card-inner'>
                        <div className='front-face'>
                            <img className='img-size' src={img} alt="" />
                            </div>
                        <div className='back-face'>
                            
                            <h2 className='blog-title'>{name}</h2>
                            <p className='blog-p'>{describtion}</p>
                            <a className='a-btn' href={Link}>Read more</a>
                            </div>

                    </div>

                </div>
           </div>
                  
              
        </div>
    );
};

export default Blog;